import React from 'react';
import { Button } from 'antd';

import { DataState, Skeleton, deriveDataState } from '../loading';

/**
 * What a settings tab shows until its first read has answered
 * (docs/platform-standards.md §14): a list skeleton, and after a failure the
 * error with Retry. Sharing, exports, imports and automations all read once
 * on open and all use it.
 *
 *   if ( ! hasData ) return <TabLoadState loading={loading} error={loadError}
 *     label='exports' errorDetail='...' onRetry={retry} />;
 *
 * Once a tab holds data it keeps showing it, and a failed reload is a
 * <RefreshFailedNotice> above the data, never a blank tab.
 */
export default function TabLoadState({ loading, error, label, errorDetail, onRetry, rows = 6 }) {
	return (
		<DataState
			className='tab-load-state'
			state={deriveDataState({ loading, error: error ? errorDetail || true : null, hasData: false })}
			skeleton={<Skeleton variant='list-row' count={rows} />}
			error={errorDetail}
			onRetry={onRetry}
			label={label}
		/>
	);
}

/** A reload failed but the tab still holds what it had: say so, offer Retry. */
export function RefreshFailedNotice({ label, onRetry }) {
	return (
		<div className='data-state__notice' role='alert'>
			<span className='data-state__notice-text'>{`Unable to refresh ${label}.`}</span>
			{onRetry ? (
				<Button className='data-state__retry' onClick={onRetry}>
					Retry
				</Button>
			) : null}
		</div>
	);
}
